import { FontSize } from "config/font";
import {
  SearchButton,
  SearchContainer,
  SearchIcon,
  SearchInput,
} from "./search.styled";

const SearchIconSVG = () => (
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

interface SearchProps {
  placeholder?: string;
  value?: string;
  fontSize?: FontSize;
  hasError?: boolean;
  showSearchButton?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSearch?: (searchValue: string) => void;
}

export const SearchComponent: React.FC<SearchProps> = (props) => {
  const handleSearchClick = () => {
    if (props.onSearch) {
      props.onSearch(props.value ? props.value : "");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (props.showSearchButton && e.key === "Enter" && props.onSearch) {
      e.preventDefault();
      props.onSearch(props.value ? props.value : "");
    }

    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  };

  return (
    <SearchContainer hasError={props.hasError} className="search-component">
      {!props.showSearchButton && (
        <SearchIcon>
          <SearchIconSVG />
        </SearchIcon>
      )}

      <SearchInput
        type="text"
        placeholder={props.placeholder ? props.placeholder : ""}
        value={props.value}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        fontSize={props.fontSize}
        onKeyDown={handleKeyDown}
        hasError={props.hasError}
        hasButton={props.showSearchButton}
        {...props}
      />

      {props.showSearchButton && (
        <SearchButton onClick={handleSearchClick}>
          <SearchIconSVG />
        </SearchButton>
      )}
    </SearchContainer>
  );
};
